import { useContext, useEffect, useMemo, type ReactNode } from 'react';
import { SATConnectionContext, SATRelinkContext } from './SATConnectionContext';
import { useSATConnection } from './useSATConnection';
import type { SATConnectionContextValue } from './satConnection.types';

const SatRelinkScope = ({ children }: { children: ReactNode }) => {
	const sat = useSATConnection();
	const setRelinking = useContext(SATRelinkContext);

	useEffect(() => {
		setRelinking(true);
		return () => setRelinking(false);
	}, [setRelinking]);

	const value = useMemo<SATConnectionContextValue>(() => {
		const inFlight =
			sat.workflowPhase === 'submitting' || sat.workflowPhase === 'polling';
		return {
			...sat,
			isLinked: false,
			isRelinking: true,
			isLinkingInFlight: inFlight,
			status: inFlight ? 'linking' : 'not_linked',
			failedReason: inFlight ? null : sat.errorMessage,
		};
	}, [sat]);

	return (
		<SATConnectionContext.Provider value={value}>
			{children}
		</SATConnectionContext.Provider>
	);
};

export default SatRelinkScope;
